import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let specialistsSwiperWr = document.querySelectorAll('.specialists-swiper-wr');
specialistsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: -16,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        641: {
          spaceBetween: -16,
          slidesPerView: 2,
        },
        768: {
          spaceBetween: -16,
          slidesPerView: 3,
        },
        1023: {
          spaceBetween: -16,
          slidesPerView: 4,
        },
        1200: {
          spaceBetween: -16,
          slidesPerView: 4,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      }
    });
    swiperObserver(swiper);

    const specialistsCardsTitlesArr = swiperEl.querySelectorAll('.specialism-card__title');

    if(specialistsCardsTitlesArr.length) {
      window.lineTitlesFunc(specialistsCardsTitlesArr);
    }
  }
});
